import { render, staticRenderFns } from "./VentaProtocoloPdf.vue?vue&type=template&id=2ac492ac&"
import script from "./VentaProtocoloPdf.vue?vue&type=script&lang=js&"
export * from "./VentaProtocoloPdf.vue?vue&type=script&lang=js&"
import style0 from "./VentaProtocoloPdf.vue?vue&type=style&index=0&id=2ac492ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports